import React from "react";
import "./styles.css"; // Assuming you create a CSS file for styles

const About = () => {
  return (
    <div className="platform-introduction">
      <h1>Welcome to your EU Tracker projects Platform</h1>
      <p className="justified-text">
        In European research and innovation projects, effective dissemination,
        communication, and exploitation are essential for ensuring that the
        project outcomes have a lasting impact. This web EuTracker platform is
        designed to streamline the management and monitoring of these
        activities, offering project partners a centralized hub to track
        progress, collaborate, and ensure the success of the project.
      </p>

      <h2>Key Features of the Platform</h2>
      <ul>
        <li className="justified-text">
          <strong>Effective Tracking:</strong> Monitor dissemination activities
          such as publications, media mentions, events, and stakeholder
          engagement in comprehensive way.
        </li>
        <li className="justified-text">
          <strong>Interactive Dashboards:</strong> Gain insights into key
          performance indicators (KPIs) related to communication and
          exploitation, and measure the impact of your outreach efforts.
        </li>
        <li className="justified-text">
          <strong>Exploitation Planning:</strong> Support long-term use and
          implementation of project innovations with tools that help track
          progress and plan the exploitation of results beyond the project’s
          lifespan.
        </li>
        <li className="justified-text">
          <strong>User-Friendly Interface:</strong> Built using ReactJS, the
          platform provides a fast, responsive, and easy-to-navigate experience
          for all project partners.
        </li>
      </ul>

      <h2>Why This Platform Matters</h2>
      <p className="justified-text">
        By providing a digital space where partners can collaborate and track
        all communication and dissemination efforts, this platform helps ensure
        that the project meets its objectives and EU guidelines. It also
        guarantees that results are effectively communicated to key
        stakeholders, such as policymakers, industry, academia, and the general
        public.
      </p>
      <p className="justified-text">
        Ultimately, this platform is a vital tool for maximizing the project’s
        visibility, boosting its impact, and ensuring that innovations are
        exploited for long-term success.
      </p>
    </div>
  );
};

export default About;
